import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Y from '../../../y18n'
import CountriesDropdown from '../../../common/dropdowns/countries-dropdown'
import LanguagesDropdown from '../../../common/dropdowns/languages-dropdown'
import RolesDropdown from '../../../common/dropdowns/roles-dropdown'
import * as userActions from '../../../store/users'
import Styles from '../../../common/styles'

const mapStateToProps = state => ({
  users: state.users
})

const mapDispatchToProps = dispatch => ({
  userActions: bindActionCreators(userActions, dispatch)
})

class NewUserDialog extends Component {
  closeFormDialog = () => {
    this.props.userActions.resetActive()
  }

  inputChanged = name => event => {
    this.props.userActions.updateActive(name, event.target.value)
  }

  submitChanges = (e, user) => {
    e.preventDefault()
    this.props.userActions.createUser(user)
  }

  render () {
    const { classes, users, userActions } = this.props
    if (!users.active || !users.new) return null

    return (
      <div>
        <Dialog
          open={users.active !== null}
          onClose={() => userActions.resetNew()}
          classes={{
            paper: classes.dialogContent
          }}
        >
          <form onSubmit={e => this.submitChanges(e, users.active)}>
            <DialogTitle>{Y`Create user`}</DialogTitle>
            <DialogContent>
              <div className={classes.flexRow}>
                <TextField
                  margin='normal'
                  label={Y`First name`}
                  type='text'
                  value={users.active.firstName || ''}
                  onChange={this.inputChanged('firstName')}
                  className={classes.flexItemLeft}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  required
                />
                <TextField
                  margin='normal'
                  label={Y`Last name`}
                  type='text'
                  value={users.active.lastName || ''}
                  onChange={this.inputChanged('lastName')}
                  className={classes.flexItemRight}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  required
                />
              </div>
            </DialogContent>
            <DialogContent>
              <TextField
                margin='normal'
                label={Y`Email`}
                type='email'
                value={users.active.email || ''}
                onChange={this.inputChanged('email')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
                required
              />
            </DialogContent>
            <DialogContent>
              <TextField
                margin='normal'
                label={Y`Phone number`}
                type='text'
                value={users.active.phoneNumber || ''}
                onChange={this.inputChanged('phoneNumber')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
                required
              />
            </DialogContent>
            <DialogContent>
              <div className={classes.flexRow}>
                <TextField
                  margin='normal'
                  label={Y`Address`}
                  type='text'
                  value={users.active.address || ''}
                  onChange={this.inputChanged('address')}
                  className={classes.flexItemLeft}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  required
                />
                <TextField
                  margin='normal'
                  label={Y`Zip code`}
                  type='text'
                  value={users.active.zipCode || ''}
                  onChange={this.inputChanged('zipCode')}
                  className={classes.flexItemMiddle}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  required
                />
                <TextField
                  margin='normal'
                  label={Y`City`}
                  type='text'
                  value={users.active.city || ''}
                  onChange={this.inputChanged('city')}
                  className={classes.flexItemRight}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  required
                />
              </div>
            </DialogContent>
            <DialogContent>
              <div className={classes.flexRow}>
                <div className={classes.flexItemLeft}>
                  <CountriesDropdown handleChange={this.inputChanged('country')} value={users.active.country || ''} />
                </div>
                <div className={classes.flexItemMiddle}>
                  <LanguagesDropdown handleChange={this.inputChanged('language')} value={users.active.language || ''} />
                </div>
                <div className={classes.flexItemRight}>
                  <RolesDropdown handleChange={this.inputChanged('role')} value={users.active.role || ''} />
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => userActions.resetNew()}>{Y`Cancel`}</Button>
              <Button type='submit' variant='raised' color='primary' style={{ color: '#fff' }}>
                {Y`Save`}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    )
  }
}

NewUserDialog = connect(mapStateToProps, mapDispatchToProps)(NewUserDialog)
export default withStyles(Styles)(NewUserDialog)



// WEBPACK FOOTER //
// ./src/pages/users/containers/new-user-dialog.js